"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Modal;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var DialogPrimitive = _interopRequireWildcard(require("@radix-ui/react-dialog"));

var VisuallyHidden = _interopRequireWildcard(require("@radix-ui/react-visually-hidden"));

var _tooltip = _interopRequireDefault(require("../tooltip"));

var _icon = _interopRequireDefault(require("../icon"));

var _modalActions = _interopRequireDefault(require("./modal-actions"));

var _eventTrap = _interopRequireDefault(require("./event-trap"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * An accessible modal dialog.
 *
 * To get a standard button arrangement at the bottom of the modal, use the
 * `primaryAction`, `secondaryAction`, and `tertiaryAction` props.
 *
 * This modal *traps focus within it*. You should be aware of that, because it
 * can sometimes introduce a hurdle when integrating the modal with other
 * things, especially third-party libraries. But it's an essential UX feature.
 */
function Modal(_ref) {
  var children = _ref.children,
      accessibleTitle = _ref.accessibleTitle,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'large' : _ref$size,
      _ref$padding = _ref.padding,
      padding = _ref$padding === void 0 ? 'large' : _ref$padding,
      _ref$allowEventBubbli = _ref.allowEventBubbling,
      allowEventBubbling = _ref$allowEventBubbli === void 0 ? false : _ref$allowEventBubbli,
      initialFocus = _ref.initialFocus,
      primaryAction = _ref.primaryAction,
      secondaryAction = _ref.secondaryAction,
      tertiaryAction = _ref.tertiaryAction,
      onExit = _ref.onExit;

  var renderActions = function renderActions() {
    if (!primaryAction) {
      return null;
    }

    return /*#__PURE__*/_react.default.createElement("div", {
      className: "mt24"
    }, /*#__PURE__*/_react.default.createElement(_modalActions.default, {
      primaryAction: primaryAction,
      secondaryAction: secondaryAction,
      tertiaryAction: tertiaryAction
    }));
  };

  var widthClass = 'wmax-full';

  if (size === 'small') {
    widthClass = 'wmax360 w-11/12';
  } else if (size === 'large') {
    widthClass = 'wmax600 w-11/12';
  }

  var overlayProps = {
    className: 'fixed top bottom left right bg-darken50',
    style: {
      display: 'grid',
      overflowY: 'auto',
      placeItems: 'start center'
    }
  };
  var rootProps = {
    defaultOpen: true
  };

  if (onExit) {
    rootProps.onOpenChange = onExit;
  }

  var contentProps = {
    className: (0, _classnames.default)("relative my12 my60-mm ".concat(widthClass, " bg-white round"), {
      'px36 py36': padding === 'large'
    })
  };

  if (initialFocus) {
    contentProps.onOpenAutoFocus = function (e) {
      var el = document.querySelector(initialFocus);

      if (el !== null) {
        e.preventDefault();
        el.focus();
      }
    };
  }

  var modal = /*#__PURE__*/_react.default.createElement(DialogPrimitive.Root, rootProps, /*#__PURE__*/_react.default.createElement(DialogPrimitive.Portal, null, /*#__PURE__*/_react.default.createElement(DialogPrimitive.Overlay, overlayProps, /*#__PURE__*/_react.default.createElement(DialogPrimitive.Content, contentProps, /*#__PURE__*/_react.default.createElement(VisuallyHidden.Root, null, /*#__PURE__*/_react.default.createElement(DialogPrimitive.Title, null, accessibleTitle)), children, renderActions(), onExit && /*#__PURE__*/_react.default.createElement(_tooltip.default, {
    content: "Close"
  }, /*#__PURE__*/_react.default.createElement("button", {
    onClick: onExit,
    type: "button",
    "data-testid": "modal-close",
    "aria-label": "Close",
    className: "btn btn--transparent unround-t unround-br color-gray py12 px12 absolute top right"
  }, /*#__PURE__*/_react.default.createElement(_icon.default, {
    name: "close"
  })))))));

  if (!allowEventBubbling) {
    return /*#__PURE__*/_react.default.createElement(_eventTrap.default, null, modal);
  }

  return modal;
}

Modal.propTypes = {
  /**
   * A screen-reader-friendly modal title. Required for accessibility.
   *
   * This **will not be displayed.** It's only for screen readers.
   * You can visually display your own header text however you'd like.
   */
  accessibleTitle: _propTypes.default.string.isRequired,

  /**
   * Invoked when the modal should close. When this callback is provided,
   * a close button will be in the top right corner, and a click on the underlay
   * or the Escape key will close the modal.
   *
   * If this prop is not provided, the close button will not be present and
   * a click on the underlay or Escape will not close the modal. The reason
   * you might not provide this function is that you want to force the user
   * to do something, instead of allowing them to sneak out of the modal.
   */
  onExit: _propTypes.default.func,

  /**
   * Modal container size. Options are `small`, `large`, or `auto`. If `auto`
   * is provided, a width is not specified.
   */
  size: _propTypes.default.oneOf(['small', 'large', 'auto']),

  /**
   * Selector for a specific element that should receive initial focus. The
   * value will be passed to `querySelector`.
   */
  initialFocus: _propTypes.default.string,

  /**
   * The content of the modal.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * `'large'` or `'none'`.
   */
  padding: _propTypes.default.oneOf(['large', 'none']),

  /**
   * The modal's primary action. If this is provided, an encouraging
   * button will be rendered at the bottom of the modal.
   *
   * Provide this and other action props if you want a standard button
   * arrangement at the bottom of the modal. If you need a more custom
   * arrangement, leave them out and insert your buttons into the content.
   *
   * The value is an object with the following properties:
   * - `text`: **(required)** The text of the button.
   * - `callback`: **(required)** Invoked when the button is clicked.
   * - `destructive`: If `true`, the [Button](#button) will be primed for
   *   desctruction.
   */
  primaryAction: _propTypes.default.shape({
    text: _propTypes.default.string.isRequired,
    callback: _propTypes.default.func.isRequired,
    destructive: _propTypes.default.bool
  }),

  /**
   * The modal's secondary action. If this is provided, a discouraging button
   * will be rendered at the bottom of the modal. See the description of
   * `primaryAction`.
   *
   * **Can only be used in combination with `primaryAction`.**
   *
   * The value is an object with the following properties:
   * - `text`: **(required)** The text of the button.
   * - `callback`: **(required)** Invoked when the button is clicked.
   */
  secondaryAction: _propTypes.default.shape({
    text: _propTypes.default.string.isRequired,
    callback: _propTypes.default.func.isRequired
  }),

  /**
   * The modal's tertiary action. **You should rarely if ever need this.**
   * If this is provided, a *very* discouraging button
   * will be rendered at the bottom of the modal. See the description of
   * `primaryAction`.
   *
   * **Can only be used in combination with `primaryAction` and
   * `secondaryAction`.**
   *
   * The value is an object with the following properties:
   * - `text`: **(required)** The text of the button.
   * - `callback`: **(required)** Invoked when the button is clicked.
   */
  tertiaryAction: _propTypes.default.shape({
    text: _propTypes.default.string.isRequired,
    callback: _propTypes.default.func.isRequired
  }),

  /**
   * We stop propagation on clicks by default to enable more intuitive
   * operation with React Portals. If you need click events to bubble up
   * to parent components, set this prop to true
   */
  allowEventBubbling: _propTypes.default.bool
};